import { Pipe, PipeTransform } from '@angular/core';
import { getActivityImageClass } from './activity.functions';

@Pipe({
  name: 'activityImageClass'
})
export class ActivityImageClassPipe implements PipeTransform {
    transform(section: string): string {
        return getActivityImageClass(section);
    }
};